import { render, staticRenderFns } from "./notatruck.vue?vue&type=template&id=126c970c&scoped=true"
import script from "./notatruck.vue?vue&type=script&lang=js"
export * from "./notatruck.vue?vue&type=script&lang=js"
import style0 from "./notatruck.vue?vue&type=style&index=0&id=126c970c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126c970c",
  null
  
)

export default component.exports